import { combineReducers, configureStore } from '@reduxjs/toolkit';

import commonReducer from './common';
import configReducer from './config';
import projectReducer from './project';
import planDataReducer from './plan-data';
// import authReducer from './auth';
// import issueReducer from './issue';
// import projectReducer from './project';
// import issueListReducer from './issue-list';
// import projectListReducer from './project-list';
// import revisionReducer from './revisions';

export const rootReducer = combineReducers({
    common: commonReducer,
    config: configReducer,
    project: projectReducer,
    planData: planDataReducer,
    // auth: authReducer,
    // issue: issueReducer,
    // project: projectReducer,
    // issueList: issueListReducer,
    // projectList: projectListReducer,
    // revision: revisionReducer,
});

const store = configureStore({
    reducer: rootReducer,
});

export default store;
